import React, { useEffect } from 'react';
import MForm from '~/app/modules/form';
import { useStoreActions, useStoreState } from '~/store';
import classes from './style.module.scss';
import WorkOrder from './WorkOrder';

export type DetailsComponent = React.FC;

const Details: DetailsComponent = () => {  
  const setIsWorkOrderFormActive = useStoreActions(action => action.service.setIsWorkOrderFormActive);
  const isWorkOrderFormActive = useStoreState(state => state.service.isWorkOrderFormActive);
  const hasSimplifiedWorkorder = useStoreState(state => state.service.hasSimplifiedWorkorder ?? false);
  const departmentId = useStoreState(state => state.service.data.departmentId);
  const user = useStoreState(state => state.user.data);

  useEffect(() => {
    setIsWorkOrderFormActive(hasSimplifiedWorkorder);
  }, [hasSimplifiedWorkorder, departmentId, setIsWorkOrderFormActive, user.department, user.departments, user.is_active]);

  return (
    <>
      <MForm className={`${classes['form']} ${classes['details']}`}>
        {isWorkOrderFormActive && <WorkOrder />}
      </MForm>
    </>
  );
};

export default Details
